export default {
  guide: {
    label: 'Beginner’s Guide',
    tips: 'You can view the beginner’s guide here~',
    title: 'Welcome to Playturbo!',
    content:
      'This is a powerful and user-friendly creation platform. Let me first introduce its core features to help you get started quickly.',
    startButton: 'Start Exploring',
    nextButton: 'Next',
    preButton: 'Previous',
    complete: 'Done',
    step1: {
      label: 'Playable Tools',
      describe: {
        title: 'Offers three creation methods:',
        content1:
          'Playable Templates: Use the Feature Creation editor to replace assets and adjust parameters based on templates, quickly exporting high-quality playable ads.',
        content2: {
          title: 'Content Editor:',
          describe1:
            'Start from scratch: Users can begin with a blank canvas and create playable ads freely like making a PowerPoint, fully customizing the content to meet diverse creative needs.',
          describe2:
            'Template-based editing: Supports layout and editing of elements on existing playable templates, allowing users to flexibly modify materials for personalized customization.',
        },
        content3:
          'Video to Playable: Convert videos into interactive videos and quickly achieve interactive effects.',
      },
    },
    step2: {
      label: 'Video Tools',
      describe: {
        title: 'Offers two creation methods:',
        content1:
          'Layout Templates: Focus on video size and multilingual adaptation, ideal for batch generation.',
        content2:
          'Video Editor: Offers fine-tuned adjustments and flexible editing for creative iteration and optimization.',
      },
    },
    step3: {
      label: 'Image Tools',
      describe: {
        title:
          'Link-to-Image helps generate image creatives in bulk. Just enter a product link — the system fetches info and samples to generate creatives in one click.',
      },
    },
    step4: {
      label: 'View Demo Project',
      describe: {
        title:
          'Each tool comes with demo projects and Help Center documentation to help you get started quickly—check out the demos that interest you!',
      },
    },
  },
}
